import { TWorkflowDefinition } from '@commenda/types';

import { IFormBuilderLinks } from '../../context/FormBuilderLinksContext';
import { WorkflowEditorContent } from './WorkflowEditorContent';
import { WorkflowEditorShell } from './WorkflowEditorShell';
import { TRenderCanvasOverlayParams, TRenderToolbarParams } from './types';

type TWorkflowEditorProps = {
  initialWorkflow?: TWorkflowDefinition;
  renderToolbar?: (params: TRenderToolbarParams) => React.ReactNode;
  renderCanvasOverlay?: (params: TRenderCanvasOverlayParams) => React.ReactNode;
  /** Given, the form step panel offers to open and create forms in the host's builder. */
  formBuilderLinks?: IFormBuilderLinks;
  /** Given, the step and group panels offer the task keys the workflow's links bind it to. */
  workflowTemplateId?: string;
  /** The editor's outermost classes. Defaults to owning the viewport; a host that puts anything
   * above the editor passes `h-full min-h-0` instead, or the default `h-screen` overflows. */
  rootClassName?: string;
};

export const WorkflowEditor = ({
  initialWorkflow,
  renderToolbar,
  renderCanvasOverlay,
  formBuilderLinks,
  workflowTemplateId,
  rootClassName,
}: TWorkflowEditorProps) => (
  <WorkflowEditorShell
    initialWorkflow={initialWorkflow}
    formBuilderLinks={formBuilderLinks}
    workflowTemplateId={workflowTemplateId}
  >
    <WorkflowEditorContent
      renderToolbar={renderToolbar}
      renderCanvasOverlay={renderCanvasOverlay}
      rootClassName={rootClassName}
    />
  </WorkflowEditorShell>
);
